<template>
  <div class="content-are">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />
    <main role="main" :class="[fullScreen ? 'full-screen-chute-grid' : 'normal-screen-chute-grid']">
      <!-- ダッシュボードのアクティブ バー -->
      <div class="dashboard-active-bar">
        <span class="dashboard-active-bar__date">{{ lastRequestDate }}</span>
        <span class="dashboard-active-bar__hour">{{ lastRequestTime }}時点</span>
        <form-select-component
          v-model="selected"
          placeholder=""
          class="multiselect-batch"
          :multiSelectCustom="true"
          :allowEmpty="false"
          :options="selectOptions"
          >
          <template slot="noOptions">
            <div>登録されていません。</div>
          </template>
          <template v-slot:singleLabel="{ itemLabel }">
            <div class="select-batch">
              <div class="select-batch__status">
                <span v-if="showIconTemporaryHolding(itemLabel.option.status, itemLabel.option.temporaryHolding)">
                  <i v-if="itemLabel.option.temporaryHolding == 0" class="material-icons">play_arrow_black</i>
                  <i v-else-if="itemLabel.option.temporaryHolding == 1" class="material-icons">pause_black</i>
                </span>
                <small v-else-if="itemLabel.option.status == 0">未割当</small>
                <small v-else-if="itemLabel.option.status == 1">割当済</small>
                <small v-else-if="itemLabel.option.status == 4">完了</small>
                <small v-else-if="itemLabel.option.status == 5">締め</small>
              </div>
              <div class="text-overflow-ellipsis"> {{ itemLabel.option.name }} {{ itemLabel.option.label }} </div>
              <span class="icon-report" v-if="itemLabel.option.missingFlag === 1 && itemLabel.option.status === 5">
                <span class="material-icons icon">report</span>
                <span class="label">未仕分けあり</span>
              </span>
            </div>
          </template>
          <template v-slot:options="{ itemOption }">
            <div class="select-batch select-batch__border">
              <div class="select-batch__status">
                <div v-if="showIconTemporaryHolding(itemOption.option.status, itemOption.option.temporaryHolding)">
                  <i v-if="itemOption.option.temporaryHolding == 0" class="material-icons">play_arrow_black</i>
                  <i v-else-if="itemOption.option.temporaryHolding == 1" class="material-icons">pause_black</i>
                </div>
                <small v-else-if="itemOption.option.status == 0">未割当</small>
                <small v-else-if="itemOption.option.status == 1">割当済</small>
                <small v-else-if="itemOption.option.status == 4">完了</small>
                <small v-else-if="itemOption.option.status == 5">締め</small>
              </div>
              <div class="text-overflow-ellipsis"> {{ itemOption.option.name }} {{ itemOption.option.label }} </div>
              <!-- <hr> -->
              <span class="icon-report" v-if="itemOption.option.missingFlag === 1 && itemOption.option.status === 5">
                <span class="material-icons icon">report</span>
                <span class="label">未仕分けあり</span>
              </span>
            </div>
          </template>
        </form-select-component>
        <!-- Button -->
        <div v-if="parseInt(selectOptions.length)" class="btn-group-custom">
              <!-- Batch Missing List Button -->
              <button class="no-bg" @click="onShowMissList" v-if="isDisplayedMissingListBtn">未仕分けリスト</button>
              <!-- Product Tracking Button -->
              <button class="no-bg" @click="onShowProductTracking()">商品追跡</button>
              <!-- Batch Detail No Button-->
              <button class="no-bg" v-if="!fullScreen" @click="onClickDetail">タスク明細</button>
          </div>
      </div>
      <!-- シュート進捗画面 -->
      <div
      :class="[ fullScreen ? 'p-0 m-0 height-chute-info' : 'card shadow-sm' ]"
      class="chute_grid_progress"
      >
        <div class="chute-grid-control d-flex align-items-center">
          <h3 class="card-title">シュート進捗</h3>
          <!-- Start Layer Dropdown -->
          <form-select-component
            v-model="chuteSelected"
            :options="chuteSelectOptions.map(chute => chute.value)"
            @onChange="setChuteLayerStorage"
            :customLabel="displayChuteLayerLabels"
            placeholder="レイヤー"
            :isNoBorder="true"
            :left="true"
          />
          <!-- End Layer Dropdown -->
          <!-- Start Chute Grid Legend -->
          <div class="d-flex chute_grid_legend">
            <template v-if="isOrderTaskType">
              <span class="chute_grid_progress_less_quarter chute_grid_progress_less_quarter__percent">~25%</span>
              <span class="chute_grid_progress_less_half chute_grid_progress_less_half__percent">~50%</span>
              <span class="chute_grid_progress_less_three_quarters chute_grid_progress_less_three_quarters__percent">~75%</span>
              <span class="chute_grid_progress_less_finish chute_grid_progress_less_finish__percent">~99%</span>
              <span class="chute_grid_progress_finish chute_grid_progress_finish__percent">100%</span>
            </template>
            <template v-else>
              <span class="chute_grid_progress_less_half chute_grid_progress_less_half__percent">走行中</span>
              <span class="chute_grid_progress_finish chute_grid_progress_finish_percent__percent ">完了</span>
            </template>
          </div>
          <!-- End Chute Grid Legend -->
          <!-- Start Chute Grid Zoom button -->
          <div class="d-flex">
            <button type="button" class="btn-zoom" @click="zoomPlus">
              <span class="material-icons zoom-in-icon">zoom_in</span>
              <span class="title">拡大</span>
            </button>
            <button type="button" class="btn-zoom" @click="zoomMinus">
              <span class="material-icons zoom-out-icon">zoom_out</span>
              <span class="title">縮小</span>
            </button>
          </div>
          <!-- End Chute Grid Zoom button -->
          <!-- Start Display Mode Dropdown -->
          <form-select-component
            v-model="modeDisplay"
            :options="modeDisplayLetters.map(modeDisplay => modeDisplay.value)"
            :customLabel="opt => modeDisplayLetters.find(modeDisplay => modeDisplay.value === opt).text"
            :isNoBorder="true"
            :left="true"
          />
          <!-- End Display Mode Dropdown -->
          <!-- Start Open Chute Grid Window -->
          <div class="icon-zoom" v-if="!fullScreen" id="icon-zoom" type="button" @click="openChuteGridWindow">
            <span class="material-icons zoom-out-map-icon">zoom_out_map</span>
            <span class="title">別タブで開く</span>
          </div>
          <!-- End Open Chute Grid Window -->
        </div>
        <!-- テーブル表示 -->
        <!-- 170px = (header + bottom space + padding + margin) -->
        <div v-if="chuteGridData !== null" class="table_wrapper" :style="{height: fullScreen ? 'calc(100vh - 170px)' : ' 448px'}"  ref="tableWrapper">
          <div class="chute_grid_table" ref="table" :style="{ width: calcTableWidth }">
            <div class="table">
              <div class="tr" v-for="(row, idx) in chuteGridData" :key="`tbtr-${idx}`">
                <div v-for="(item, idx2) in row" :key="`tbtd-${idx2}`"
                    class="td"
                    :class="{
                      'start': idx == 0 ||  chuteGridData[idx - 1][idx2].chute_no != item.chute_no,
                      'end': idx+1 == chuteGridData.length || chuteGridData[idx + 1][idx2].chute_no != item.chute_no,
                      'no-progress' : !item.status
                    }"
                    :style="{ width: cellWidth + 'px', height: cellHeight+4 + 'px', 'font-size': calcCellFont.size + 'px' }"
                >
                  <div
                    v-if="item.chute_no"
                    class="td-cotnent text-center"
                    :class="[chuteCellColorClass[item.color_index], item.full_flag === 1 ? 'full-chute' : '']"
                    :id="`tooltip-target-${idx}-${idx2}`"
                    :tabindex="0"
                    :style="`--chuteStatusFontSize: ${calcCellFont.chuteStatusFontSize}; --chuteNameFontSize: ${calcCellFont.chuteNameFontSize}` "
                  >
                    <template v-if="modeDisplay === DEFAULT_CHUTE_DISPLAY_MODE">
                      <span v-if="item.chute_no && item.statusNum == STATUS_STOP" class="chute-stop">
                        <i v-if="cellWidth > 40" class="material-icons" :style="{ width: calcCellFont.chuteIconFontSize + 'px', height: calcCellFont.chuteIconFontSize + 'px', fontSize: calcCellFont.chuteIconFontSize + 'px' }">block_black</i>
                      </span>
                      <p v-if="cellWidth > 20 && (idx == 0 ||  chuteGridData[idx - 1][idx2].chute_no != item.chute_no)" class="chute_status">{{ item.status }}</p>
                      <p v-if="showChuteName" class="chute_info chute_name">
                        <span v-if="cellWidth > 40">
                          <span v-if="item.chute_name">{{ item.chute_name }}</span>
                          <span v-else>{{ item.chute_no }}<span v-if="item.chute_branch_no">-{{ item.chute_branch_no }}</span></span>
                        </span>
                      </p>
                      <p v-if="!showChuteName" class="chute_info chute_no chute_name"><span v-if="cellWidth > 40">{{ item.chute_no }}<span v-if="item.chute_branch_no">-{{ item.chute_branch_no }}</span></span></p>
                      <b-tooltip :disabled="!item.chute_no || item.statusNum == STATUS_STOP" :target="`tooltip-target-${idx}-${idx2}`" placement="top" triggers="click blur" custom-class="chute-grid-tooltip">
                          <span v-if="item.full_flag === 0 && item.statusNum != STATUS_STOP" class="status">{{ item.status }}</span>
                          <span>{{ item.chute_name }}</span>
                          <span>{{ item.chute_no }}<span v-if="item.chute_branch_no">-{{ item.chute_branch_no }}</span></span>
                      </b-tooltip>
                    </template>
                    <template v-else-if="modeDisplay === PRIORITY_CHUTE_NAME_DISPLAY_MODE">
                      <span v-if="item.chute_no && item.statusNum == STATUS_STOP" class="chute-stop">
                        <i v-if="cellWidth > 40" class="material-icons" :style="{ width: calcCellFont.chuteIconFontSize + 'px', height: calcCellFont.chuteIconFontSize + 'px', fontSize: calcCellFont.chuteIconFontSize + 'px' }">block_black</i>
                      </span>
                      <p v-if="cellWidth > 20 && (idx == 0 ||  chuteGridData[idx - 1][idx2].chute_no != item.chute_no)" class="chute_status">{{ item.status }}</p>
                      <p class="chute_info chute_name">
                        <span v-if="cellWidth > 40">
                          <span v-if="item.chute_name">{{ item.chute_name }}</span>
                          <span v-else>{{ item.chute_no }}<span v-if="item.chute_branch_no">-{{ item.chute_branch_no }}</span></span>
                        </span>
                      </p>
                      <b-tooltip :disabled="!item.chute_no || item.statusNum == STATUS_STOP" :target="`tooltip-target-${idx}-${idx2}`" placement="top" triggers="click blur" custom-class="chute-grid-tooltip">
                        <span v-if="item.full_flag === 0 && item.statusNum != STATUS_STOP" class="status">{{ item.status }}</span>
                        <span>{{ item.chute_name }}</span>
                        <span>{{ item.chute_no }}<span v-if="item.chute_branch_no">-{{ item.chute_branch_no }}</span></span>
                      </b-tooltip>
                    </template>
                    <template v-else-if="modeDisplay === ONLY_CHUTE_NO_DISPLAY_MODE">
                      <span v-if="item.chute_no && item.statusNum == STATUS_STOP" class="chute-stop">
                        <i v-if="cellWidth > 40" class="material-icons" :style="{ width: calcCellFont.chuteIconFontSize + 'px', height: calcCellFont.chuteIconFontSize + 'px', fontSize: calcCellFont.chuteIconFontSize + 'px' }">block_black</i>
                      </span>
                      <p v-if="cellWidth > 20 && (idx == 0 ||  chuteGridData[idx - 1][idx2].chute_no != item.chute_no)" class="chute_status">{{ item.status }}</p>
                      <p class="chute_info chute_no chute_name"><span v-if="cellWidth > 40">{{ item.chute_no }}<span v-if="item.chute_branch_no">-{{ item.chute_branch_no }}</span></span></p>
                      <b-tooltip :disabled="!item.chute_no || item.statusNum == STATUS_STOP" :target="`tooltip-target-${idx}-${idx2}`" placement="top" triggers="click blur" custom-class="chute-grid-tooltip">
                        <span v-if="item.full_flag === 0 && item.statusNum != STATUS_STOP" class="status">{{ item.status }}</span>
                        <span>{{ item.chute_name }}</span>
                        <span>{{ item.chute_no }}<span v-if="item.chute_branch_no">-{{ item.chute_branch_no }}</span></span>
                      </b-tooltip>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- グラフ描画 -->
      <div class="row" v-if="!fullScreen">
        <div class="col-5 pr-8">
          <div class="col-12 card shadow-sm">
            <h3 class="card-title"> {{isOrderTaskType ? 'タスク消化率' : 'タスク消化数'}}</h3>
            <div class="d-flex justify-content-center align-items-center">
              <div class="pie-chart">
                 <pie-chart
                 :options = pie_options
                 />
                <p
                  class="donut_empty_data"
                  v-if="isNoDataPieChart"
                >no data</p>
              </div>
              <ul class="donut_legend">
                <li
                  v-for="(taskVal, statusName) in taskData.taskForGraph || colors"
                  :key="statusName"
                  class="d-flex justify-content-between align-items-center"
                >
                  <span class="status_text">
                    <span class="circle_color" v-bind:style="{'border-color': colors[statusName]}"></span>
                    {{statusName}}
                  </span>
                  <span class="percent">
                    {{ getTaskProgressPercent(taskVal.taskCount, taskData.allTaskCount) }}
                    <small v-if="isOrderTaskType">%</small>
                  </span>
                </li>
              </ul>
            </div>
            <div class="d-flex justify-content-center align-items-center progress_text">
              <div class="label">総タスク数</div>
              <div class="number">
                <span class="mole">{{ getTaskProgressIndicator(taskData.taskCompleteCount, taskData.allTaskCount) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-7 pl-8">
          <div class="col-12 card shadow-sm">
            <h3 class="card-title m-0">シュートNo別進捗</h3>
            <div class="barwrap" style="overflow-x: hidden; height: 100%;">
              <horizontal-bar
                :style="calcHorizonntalBar"
                :chart-data="horizontalData"
                :options="options"
                :ticks-max="options.scales.xAxes[0].ticks.max"
                :labelcount="(horizontalData) ? horizontalData.labels.length: 0"
              />
            </div>
            <p class="empty_data" v-if="!horizontalData || !horizontalData.datasets.length">no data</p>
            <div class="chute_lagend">
              <span class="comp">完了</span>
              <span class="incomp">未完了</span>
            </div>
            <div class="d-flex justify-content-center align-items-center progress_text">
              <div class="label">完了シュート数</div>
              <div class="number">
                <span class="mole">{{ getTaskProgressIndicator(taskData.chuteCompleteCount, taskData.chuteTotalCount) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <missing-items-modal
        ref="missing-items-modal"
        v-model="isShowMissingModal"
        :isShowBatchDetailNo="isShowBatchDetailNo"
      />
      <item-tracking-modal
        ref="item-tracking-modal"
        v-model="isShowTrackingModal"
        :isOrderTaskType="isOrderTaskType"
      />
    </main>
  </div>
</template>

<script>
import HorizontalBar from './custom-components/HorizontalBar.vue'
import PieChart from './custom-components/PieChart.vue'
import FlashMessage from '../common/flash-message.component'
import Loading from 'vue-loading-overlay'
import { mapActions, mapGetters, mapState } from 'vuex'
import AppConstants from '../constants/app.constants'
import MissingItemsModal from './modal/MissingItemsModal.vue'
import RouterUtils from '../_helpers/router.util'
import BatchTaskUtils from '../_helpers/batch-task.util'
import ItemTrackingModal from './modal/ItemTrackingModal.vue'
import FormSelectComponent from './custom-components/FormSelectComponent.vue'
import CommonUtils from '../mixins/commonUtils.js'
import WindowUtils from '../_helpers/window.util'
import NumberUtils from '../_helpers/number.util'
import { store } from '@/store.js'
const defaultCellWidth = 60
const defaultCellHeight = 60
const minCellWidth = 20
const zoomSpan = 20
const STATUS_STOP = 0
const DEFAULT_CHUTE_DISPLAY_MODE = 0
const PRIORITY_CHUTE_NAME_DISPLAY_MODE = 1
const ONLY_CHUTE_NO_DISPLAY_MODE = 2
export default {
  components: { HorizontalBar, PieChart, Loading, ItemTrackingModal, MissingItemsModal, FormSelectComponent },
  mixins: [CommonUtils],
  async created() {
    if (this.isSocketEnabled()) {
      await this.getDashboardLastSendTimeMillisecond()
    }
    await this.$initialize()
    this.initGraphDataFetchingInterval()
  },
  watch: {
    async selected(newValue, oldValue) {
      if (!newValue || (oldValue && newValue.value === oldValue.value)) {
        return
      }
      await this.onChangeBatch(newValue, oldValue)
    },
    async messages(newValue, oldValue) {
      // メッセージング通知が(CHUTE/BATCH/TASK)の場合にダッシュボード画面をリロードするためのハンドル。
      if (Array.isArray(newValue) && AppConstants.DASHBOARD_SOCKET.some(s => newValue.indexOf(s) >= 0)) {
        this.setMessages([])
        const dateTimeNow = new Date().getTime()
        const isChuteMessage = newValue.includes(AppConstants.CHUTE_SOCKET)
        if (!this.lastSendTimeMillisecond || dateTimeNow - this.lastSendTimeMillisecond > this.dashboardLastSendTime) {
          // 新しいデータを取得するために使用される共通フラグをリセットする。
          this.pageReload = false
          this.isReloadChute = false
          // 最後に送信された時刻の値を覚えておいてください。
          this.lastSendTimeMillisecond = dateTimeNow
          // 新しい欠落データと追跡データを取得する。
          await this.fetchTrackingData()
          await this.fetchMissingData()
          // チェックしてシュート設定データを取得。
          if (isChuteMessage) {
            await this.featchChuteSettingData()
          }
          // 新しいデータを取得し。
          await this.fetchGraphData(true)
        } else {
          // ページ リロード ウォッチャーでタイマーを介して新しいデータをフェッチするための共通フラグを設定します。
          this.pageReload = true
          this.isReloadChute = isChuteMessage
        }
      }
    },
    '$store.state.reconnectedFlag': async function(newValue) {
      if (newValue) {
        await this.getDashboardLastSendTimeMillisecond()
        await this.$initialize()
        this.initGraphDataFetchingInterval()
      }
    },
    modeDisplay() {
      this.setChuteInfoDisplay()
    },
    pageReload(newValue, oldValue) {
      if (!this.pageReload) {
        return
      }
      let delayedTime = this.dashboardLastSendTime - (new Date().getTime() - this.lastSendTimeMillisecond)
      this.dataFetchingTimer = setTimeout(async () => {
        if (!this.pageReload) {
          return
        }
        this.pageReload = false
        // 新しい欠落データと追跡データを取得する。
        await this.fetchTrackingData()
        await this.fetchMissingData()
        // シュート画面が変更され、ソケットがオンになっている場合、API が再度呼び出されます。
        if (this.isReloadChute) {
          await this.featchChuteSettingData()
        }
        await this.fetchGraphData(true)
      }, delayedTime)
    }
  },
  mounted() {
    // 新しいウィンドウを開くをチェック
    const reopenChuteGridWindowFlag = store.getters.getReopenChuteGridWindowFlag
    if (reopenChuteGridWindowFlag) {
      WindowUtils.openMaximizedWindow(AppConstants.CHUTE_GRID_WINDOW, 'fullscreen=true')
      store.commit('setReopenChuteGridWindowFlag', 0)
    }
    if (this.fullScreen) {
      const selectedBatch = this.getBatchSelected
      if (selectedBatch) {
        const batchObject = BatchTaskUtils.getBatchNoAndBatchDetailNo(selectedBatch)
        // バッチ選択をクエリパラメータに割り当てる
        this.queryParam = {
          ...batchObject
        }
      }
      document.body.className = 'custom-bg-white'
      this.updateMenuStatus(0)
    }

    // ユーザーが変更された場合、シュートセルのサイズを更新します。
    if (Object.keys(this.chuteZoomValueStorage).length > 0) {
      this.cellWidth = this.chuteZoomValueStorage.cellWidth
      this.cellHeight = this.chuteZoomValueStorage.cellHeight
    } else {
      // デフォルトのシュートセル サイズ。
      if (this.windowWidth > 1194 && this.cellWidth === defaultCellWidth && this.cellHeight === defaultCellHeight) {
        this.cellWidth = 80
        this.cellHeight = 80
      }
    }

    // ストレージ内のシュート表示情報を取得します。
    if (this.chuteInfoDisplayStorage) {
      this.modeDisplay = this.chuteInfoDisplayStorage
    }
    window.addEventListener('resize', this.onResize)
    // 3 秒後、showChuteName フラグを 1 回変更します。
    setInterval(() => {
      this.changeChuteNameNo()
    }, 3000)
  },
  beforeDestroy() {
    this.stopDashboardInterval = true
    this.resetTimer()
    clearTimeout(this.dataFetchingTimer)
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    /**
     * 完了数と合計数に基づいてタスクの進行状況インジケーターを生成します。
     *
     * @param {number|undefined} completedCount 完了したタスクの数
     * @param {number|undefined} totalCount タスクの合計数
     * @returns {string} 完了したタスクと合計タスクを表す進行状況インジケーター文字列。
     */
    getTaskProgressIndicator(completedCount, totalCount) {
      if (this.isOrderTaskType) {
        return this.isLoading || NumberUtils.isNil(completedCount, totalCount) ? AppConstants.DASHBOARD_ORDER_TASK_PROGRESS_NA : `${completedCount} / ${totalCount}`
      }
      return this.isLoading || NumberUtils.isNil(completedCount) ? AppConstants.DASHBOARD_NO_TASK_PROGRESS_NA : completedCount
    },
    /**
     * 完了したタスクの進捗率を計算します。
     *
     * @param {number} taskCount 進行中のタスクの数
     * @param {number} allTaskCount すべてのタスクの合計数
     * @returns {string|number} 進行状況のパーセンテージ、または条件が満たされない場合の特別な値
     */
    getTaskProgressPercent(taskCount, allTaskCount) {
      if (this.isLoading || (!taskCount && taskCount !== 0) || !allTaskCount) {
        return AppConstants.DASHBOARD_NO_TASK_PROGRESS_NA
      }
      if (this.isOrderTaskType) { // 注文タスクの並べ替えの場合
        let percentageVal = Number.parseFloat((taskCount / allTaskCount) * 100)
        percentageVal = Math.floor(percentageVal * 100) / 100
        return percentageVal.toFixed(2)
      }
      // タスクソートなしの場合
      return taskCount
    },
    /**
     * ウィンドウのサイズ変更
     */
    async onResize() {
      this.drawDashboardCharts(this.dashboard)
    },
    /**
     * ダッシュボード チャートを描画します。
     *
     * @param {object} dashboardData - チャートを構築するためのデータ
     */
    drawDashboardCharts(dashboardData) {
      const data = dashboardData && dashboardData.data
      if (!data) {
        return
      }
      this.$_createCircleData(data.batches)
      this.$_createHorizontalData(data.chutes)
      this.$_createChuteGridData(data.chuteProgress)
    },
    ...mapGetters('setting', ['getSetting']),
    ...mapGetters('socket', ['isSocketEnabled']),
    ...mapActions('socket', ['setMessages']),
    ...mapActions('dashboard', ['updateChuteZoomValue', 'updateChuteInfoDisplay', 'updateChuteLayer',
      'updateChuteZoomValueFullscreen', 'updateChuteInfoDisplayFullscreen', 'updateChuteLayerFullscreen', 'updateBatchSelected']),
    ...mapActions('settingWizardStore', ['updateMenuStatus']),
    async $initialize() {
      await this.featchChuteSettingData()
      await this.fetchGraphData(true)
    },
    /**
     * チェックして、グラフ データのフェッチ間隔を初期化します。
     */
    initGraphDataFetchingInterval() {
      // ソケットの再接続時に常に以前のリセットタイマー。
      if (this.intervalId) {
        this.resetTimer()
      }
      const isSocketEnabled = this.isSocketEnabled()
      if (!isSocketEnabled && !this.stopDashboardInterval) {
        this.intervalId = setInterval(async () => {
          const stopIntervalApi = localStorage.getItem(AppConstants.STOP_INTERVAL_API_FLAG)
          if (this.stopDashboardInterval || stopIntervalApi === 'true') {
            this.resetTimer()
            return
          }
          await this.fetchGraphData(false)
        }, this.$moment.duration(this.intervalTime, 'seconds').asMilliseconds())
      }
    },
    /**
     * 新しい欠損データを取得する。
     */
    async fetchMissingData() {
      if (this.isShowMissingModal) {
        await this.$refs['missing-items-modal'].generateMissingItems()
      }
    },
    /**
     * 新しい追跡データを取得する。
     */
    async fetchTrackingData() {
      if (!this.isShowTrackingModal) {
        return
      }
      const trackingModal = this.$refs['item-tracking-modal']
      if (trackingModal.isNotNullScanCode()) {
        await trackingModal.onSearch()
      }
    },
    /**
     * showChuteName フラグを変更して、chuteName または chuteNo を表示します。
     */
    changeChuteNameNo() {
      this.showChuteName = !this.showChuteName
    },
    /**
     * バッチが変更された時に呼び出される非同期関数です。
     *
     * @param {any} newValue - 新しいバッチの値
     * @param {any} oldValue - 古いバッチの値
     */
    async onChangeBatch(newValue, oldValue) {
      this.batchSelected = newValue.value
      const batchObject = BatchTaskUtils.getBatchNoAndBatchDetailNo(newValue.value)
      // バッチ変更時はレイヤーの選択をクリア
      this.queryParam = {
        ...batchObject
      }
      this.queryStr = newValue ? `?batchNo=${RouterUtils.encodedUrlParam(batchObject['batchNo'])}&batchDetailNo=${batchObject['batchDetailNo']}` : ''
      const dataDashboard = this.dashboard.data
      if (!oldValue ||
          (dataDashboard.batchNo && dataDashboard.batchDetailNo &&
            dataDashboard.batchNo === batchObject.batchNo &&
            dataDashboard.batchDetailNo.toString() === batchObject.batchDetailNo.toString())
      ) {
        return
      }
      this.isBatchChanged = true
      this.isLoading = true
      await this.fetchGraphData(true)
    },
    async featchChuteSettingData() {
      try {
        this.gridxSize = 0
        this.gridySize = 0
        const response = await this.$axios.get(`/master/chute`)
        const resluts = response.data.mstChute
        resluts.filter(item => item.gridx && item.gridy).map(item => {
          if (this.gridxSize < item.gridx) {
            this.gridxSize = item.gridx
          }
          if (this.gridySize < item.gridy) {
            this.gridySize = item.gridy
          }
        })
      } catch (error) {
        FlashMessage.getInstance().parseAndShowErrorMessage(error)
      }
      if (!this.isSocketEnabled()) {
        const result = this.getSetting()
        if (result && result.data && result.data.mstSetting) {
          this.intervalTime = result.data.mstSetting.anaScmUpdSeconds
        }
      }
    },
    async fetchGraphData(isAlwaysDisplayData) {
      try {
        if (!isAlwaysDisplayData && this.isGettingData) {
          // skip this request if there is another request to load data
          return
        }
        this.isGettingData = true
        this.lastRequestDate = this.$moment().format('MM/DD')
        this.lastRequestTime = this.$moment().format('H:mm:ss')
        this.dashboard = await this.$axios.get(
          `/dashboard`, {params: this.queryParam}
        )
        let noWorkTaskTypeList = this.dashboard.data.noWorkTaskType || []
        let trBatchList = this.dashboard.data.trBatch || []
        if (!trBatchList.length) {
          this.queryParam = {}
        }
        if (!isAlwaysDisplayData && this.isBatchChanged) {
          this.isBatchChanged = false
          this.isGettingData = false
          this.isLoading = false
          // the result will not be displayed on GUI if there is another request
          // to load data in case user changes batch name
          return
        }
        // バッチが取得されるまでは選択値は設定しない
        if (trBatchList.length && this.dashboard.data.batchNo !== null) {
          // 選択変数が null の場合に値を設定する
          this.isShowBatchDetailNo = this.checkChildrenBatchExistent(trBatchList, this.dashboard.data.batchNo)
          if (this.selected === null) {
            const selected = trBatchList.find((value) => {
              return value.batchDetailNo === this.dashboard.data.batchDetailNo && value.batchNo === this.dashboard.data.batchNo
            })
            this.selected = {
              value: `${this.dashboard.data.batchNo}-${this.dashboard.data.batchDetailNo}`,
              name: selected.batchName,
              label: this.isShowBatchDetailNo ? `${this.dashboard.data.batchNo}-${this.dashboard.data.batchDetailNo}` : this.dashboard.data.batchNo,
              status: selected.status,
              temporaryHolding: selected.temporaryHolding,
              missingFlag: selected.missingFlag,
              isNoWorkTaskType: noWorkTaskTypeList.includes(selected.taskType)
            }
          } else {
            const batchObject = BatchTaskUtils.getBatchNoAndBatchDetailNo(this.selected.value)
            // バッチの新しいステータスを取得が選択されています
            const batchNewStatus = trBatchList.find((value) => {
              return value.batchNo === batchObject['batchNo'] && value.batchDetailNo === parseInt(batchObject['batchDetailNo'])
            })
            if (batchNewStatus &&
              (batchNewStatus.status !== this.selected.status ||
              batchNewStatus.temporaryHolding !== this.selected.temporaryHolding ||
              batchNewStatus.missingFlag !== this.selected.missingFlag)) {
              // バッチが変更された場合、このバッチは更新されます
              this.selected.label = this.isShowBatchDetailNo ? `${batchNewStatus.batchNo}-${batchNewStatus.batchDetailNo}` : batchNewStatus.batchNo
              this.selected.status = batchNewStatus.status
              this.selected.temporaryHolding = batchNewStatus.temporaryHolding
              this.selected.missingFlag = batchNewStatus.missingFlag
              this.selected.isNoWorkTaskType = noWorkTaskTypeList.includes(batchNewStatus.taskType)
            } else if (!batchNewStatus) {
              // 選択されたバッチが削除された場合、次のバッチを選択
              this.selected = {
                value: `${trBatchList[0].batchNo}-${trBatchList[0].batchDetailNo}`,
                name: trBatchList[0].batchName,
                label: this.isShowBatchDetailNo ? `${trBatchList[0].batchNo}-${trBatchList[0].batchDetailNo}` : trBatchList[0].batchNo,
                status: trBatchList[0].status,
                temporaryHolding: trBatchList[0].temporaryHolding,
                missingFlag: trBatchList[0].missingFlag,
                isNoWorkTaskType: noWorkTaskTypeList.includes(trBatchList[0].taskType)
              }
            }
          }
        } else {
          // バッチリストが空の場合、デフォルト値にリセット
          this.selected = null
          this.queryStr = null
          this.selectOptions = []
        }
        this.selectOptions = []
        // 各バッチ番号の出現回数をカウントし、それぞれのバッチに対する適切なラベルを作成して選択肢に追加します。
        const countBatchNoValueOccurrences = trBatchList.reduce((count, batch) => {
          count[batch.batchNo] = (count[batch.batchNo] || 0) + 1
          return count
        }, {})
        for (let v of trBatchList) {
          this.selectOptions.push({
            value: `${v.batchNo}-${v.batchDetailNo}`,
            label: countBatchNoValueOccurrences[v.batchNo] > 1 ? `${v.batchNo}-${v.batchDetailNo}` : v.batchNo,
            name: v.batchName,
            status: v.status,
            temporaryHolding: v.temporaryHolding,
            missingFlag: v.missingFlag,
            isNoWorkTaskType: noWorkTaskTypeList.includes(v.taskType)
          })
        }
        // 最大化ウィンドウを開いたときにバッチを保持します。
        if (this.fullScreen && this.getBatchSelected && this.selectOptions.length > 0) {
          const batchSelected = this.selectOptions.findIndex(batch => batch.value === this.getBatchSelected)
          this.selected = this.selectOptions[batchSelected !== -1 ? batchSelected : 0]
          // ストレージで選択されたバッチをリセットします。
          this.updateBatchSelected('')
        }
        if (this.dashboard.data.batches) {
          const taskForGraph = this.dashboard.data.batches.taskForGraph
          if (this.isNoWorkTaskType && taskForGraph) {
            const filteredTaskForGraph = Object.keys(taskForGraph)
              .filter(key => !AppConstants.NO_TASK_SORT_HIDDEN_TASK_PROGRESS_STATUS.includes(key))
              .reduce((obj, key) => {
                obj[key] = taskForGraph[key]
                return obj
              }, {})
            this.dashboard.data.batches.taskForGraph = filteredTaskForGraph
          }
        }
        this.taskData = this.dashboard.data.batches || {}
        this.drawDashboardCharts(this.dashboard)
        this.isGettingData = false
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.isGettingData = false
        console.log(error)
        FlashMessage.getInstance().parseAndShowErrorMessage(error)
      }
    },
    /**
     * バッチリスト内の特定のバッチ番号の出現回数を調べます。
     * @param {array} batchList - 処理対象のバッチリスト
     * @param {string} batchNo - カウントするバッチ番号
     * @returns {boolean} - バッチNoが2回以上出現する場合はtrue、それ以外はfalseを返します
     */
    checkChildrenBatchExistent (batchList, batchNo) {
      return batchList.filter((value) => value.batchNo === batchNo).length > 1
    },
    $_createCircleData(taskData) {
      if (taskData) {
        let data = []
        let valueZero = true
        for (let key in taskData.taskForGraph) {
          const task = taskData.taskForGraph[key]
          let chartData = {}
          chartData.value = task.taskCount
          chartData.name = key
          chartData.itemStyle = {}
          chartData.itemStyle.color = this.colors[key]
          data.push(chartData)
          if (task.taskCount > 0) {
            valueZero = false
          }
        }
        if (!valueZero) {
          this.pie_options.series[0].data = data
          this.pie_options.series[0].silent = false
          this.pie_options.tooltip.show = true
          this.pie_options.animation = true
        } else {
          this.pie_options.series[0].data = []
        }
      } else {
        this.pie_options.series[0].data = [{
          value: 1,
          name: 'No data',
          itemStyle: {
            color: '#eeeeee'
          }
        }]
        this.pie_options.series[0].silent = true
        this.pie_options.tooltip.show = false
        this.pie_options.animation = false
      }
    },
    /**
     *  横棒グラフデータ作成
     */
    $_createHorizontalData(chutes) {
      this.horizontalData = {}
      this.horizontalData.labels = []
      this.horizontalData.datasets = []
      const chuteData = chutes ? chutes.chuteForGraph : {}
      // データエンプティ
      if (!Object.keys(chuteData).length) {
        this.options.scales.xAxes[0].ticks.max = 10
        return
      } else {
        // 最大ティック値をリセット
        this.options.scales.xAxes[0].ticks.max = undefined
      }
      // オブジェクトからソートされたES6マップに変換する
      let sortedChuteData = new Map(Object.entries(chuteData))
      sortedChuteData = new Map([...sortedChuteData.entries()].sort())

      // let max = Math.max(
      //   ...Object.keys(chuteData).map(m => chuteData[m].taskTotalCountByChute)
      // )
      // const diffNum = 10 - (max % 5)
      // this.options.scales.xAxes[0].ticks.max = 0
      this.horizontalData.datasets = [
        {
          label: '完了済み',
          data: [],
          maxBarThickness: 30,
          backgroundColor: '#AFAFAE',
          isNoWorkTaskType: this.selected && this.selected.isNoWorkTaskType
        },
        {
          label: '未完了',
          data: [],
          maxBarThickness: 30,
          backgroundColor: '#D2DAFE',
          isNoWorkTaskType: this.selected && this.selected.isNoWorkTaskType
        }
      ]

      this.totalTaskByChute = 0
      this.totalTaskByChuteCompleted = 0
      for (let [key, chute] of sortedChuteData) {
        this.horizontalData.labels.push(key)
        this.totalTaskByChuteCompleted += chute.taskCompleteCountByChute
        this.totalTaskByChute += chute.taskTotalCountByChute
        this.horizontalData.datasets[0].data.push(
          chute.taskCompleteCountByChute
        )
        this.horizontalData.datasets[1].data.push(
          chute.taskNonCompleteCountByChute
        )
      }
    },
    /* シュート進捗画面データ作成 */
    $_createChuteGridData(chuteProgress) {
      // レイヤーを作成
      const layoutData = chuteProgress ? chuteProgress.chuteForLayoutDrawing : {}
      this.chuteLayers = []
      for (let key in layoutData) {
        this.chuteLayers.push(key)
      }
      this.chuteLayers.sort((layer1, layer2) => layer1 - layer2)
      // シュート層が変更されたときにシュート オプションをリセットします。
      this.chuteSelectOptions = []
      if (this.chuteLayers.length > 0) {
        for (let i = 0, len = this.chuteLayers.length; i < len; i++) {
          this.chuteSelectOptions.push({
            value: i,
            text: this.chuteLayers[i]
          })
        }
      } else {
        // シュートレイヤーがない場合は、選択したシュートをヌルに変更します
        this.chuteSelected = null
        this.setChuteLayerStorage(0)
      }
      // グリッド枠を再作成
      this.chuteGridDatas = []
      this.countByLayerData = []
      for (let i = 0, len = this.chuteLayers.length; i < len; i++) {
        this.countByLayerData.push({ chuteCompleteCount: null, chuteTotalCount: null, taskCompleteCount: null, taskTotalCount: null })
        this.chuteGridDatas[i] = []
        for (let j = 0; j < this.gridySize; j++) {
          this.chuteGridDatas[i][j] = []
          for (let k = 0; k < this.gridxSize; k++) {
            this.chuteGridDatas[i][j][k] = { chute_no: '', chute_branch_no: '', chute_name: '', status: '', progress: '', color_index: 0, title: '' }
          }
        }
      }
      // シュート進捗データを展開
      const isNoWorkTaskType = this.isNoWorkTaskType
      for (let key in layoutData) {
        const layerIndex = this.chuteLayers.indexOf(key)
        if (layerIndex === -1) { continue }
        // シュート数・作業指示数
        this.countByLayerData[layerIndex].chuteCompleteCount = layoutData[key].chuteCompleteCountByLayer
        this.countByLayerData[layerIndex].chuteTotalCount = layoutData[key].chuteTotalCountByLayer
        this.countByLayerData[layerIndex].taskCompleteCount = layoutData[key].taskCompleteCountByLayer
        this.countByLayerData[layerIndex].taskTotalCount = layoutData[key].taskTotalCountByLayer
        // 進捗データ
        const chuteProgressData = layoutData[key].chuteProgressDataByLayer
        for (let i = 0, len = chuteProgressData.length; i < len; i++) {
          const item = chuteProgressData[i]
          if (item.gridx === null || item.gridy === null || item.layer === null) { continue }
          if (item.gridx > this.gridxSize || item.gridy > this.gridySize) { continue }
          let cellItem = { chute_no: '', chute_name: '', status: '', progress: '', color_index: 0, title: '', full_flag: 0 }
          cellItem.chute_no = item.chuteNo
          cellItem.chute_branch_no = item.chuteBranchNo
          cellItem.chute_name = (item.chuteName !== null && item.chuteName.length > 10) ? item.chuteName.substring(0, 10) : item.chuteName
          cellItem = this.setChuteGridColor(cellItem, item.chuteProgressRate, isNoWorkTaskType)
          if (item.taskCompleteCountByChute || item.taskTotalCountByChute) {
            let status = item.taskCompleteCountByChute.toString()
            if (!isNoWorkTaskType) {
              status += '/' + item.taskTotalCountByChute
            }
            cellItem.status = status
          }
          cellItem.title = cellItem.chute_no + '\n' + cellItem.chute_name + '\n' + (cellItem.progress !== null ? cellItem.progress + '%' : '-')
          cellItem.full_flag = item.fullFlag
          cellItem.statusNum = item.status
          this.chuteGridDatas[layerIndex][item.gridy - 1][item.gridx - 1] = cellItem
        }
      }
      // データ シュートが変更された場合は、シュート レイヤを確認して選択します。データ シュートが変更された場合は、シュート レイヤを確認して選択します。
      let chuteIndex = 0
      if (!this.chuteLayers.length) {
        this.chuteSelected = null
      } else {
        // 店内のシュートがシュートレイヤー配列に存在する場合、店内のシュートが選択されます
        // それ以外の場合は、最初のシュート レイヤーが選択されます。
        chuteIndex = this.findIndexChuteLayer(this.chuteLayerStorage)
        this.chuteSelected = chuteIndex
      }
      this.setChuteLayerStorage(chuteIndex)
    },
    /**
     * シュートの進行速度とタスクの種類に基づいて、シュート グリッド セル項目のカラー インデックスを設定します。
     *
     * @param {Object} cellItem カラーインデックスで更新されるセル項目オブジェクト
     * @param {number|null} chuteProgressRate シュート進行率の値。
     * @param {boolean} isNoWorkTaskType タスクの種類が非作業タスクかどうかを示すフラグ。
     * @returns {Object|null} カラーインデックスを持つ更新されたセル項目オブジェクト、または cellItem が null の場合は null。
     */
    setChuteGridColor(cellItem, chuteProgressRate, isNoWorkTaskType) {
      if (!cellItem) {
        return null
      }

      if (!chuteProgressRate && chuteProgressRate !== 0) {
        cellItem.color_index = 1
        return cellItem
      }

      if (isNoWorkTaskType) {
        if (chuteProgressRate === 100) {
          cellItem.color_index = 5
        } else {
          cellItem.color_index = 2
        }
      } else {
        if (chuteProgressRate <= 25) {
          cellItem.color_index = 1
        } else if (chuteProgressRate <= 50) {
          cellItem.color_index = 2
        } else if (chuteProgressRate <= 75) {
          cellItem.color_index = 3
        } else if (chuteProgressRate <= 99) {
          cellItem.color_index = 4
        } else if (chuteProgressRate === 100) {
          cellItem.color_index = 5
        }
      }
      return cellItem
    },
    /* 拡大 */
    zoomPlus() {
      this.cellWidth += zoomSpan
      this.cellHeight += zoomSpan
      let zoomPlus = {cellWidth: this.cellWidth, cellHeight: this.cellHeight}
      this.setZoomValueStorage(zoomPlus)
    },
    /* 縮小 */
    zoomMinus() {
      if (this.cellWidth > minCellWidth) {
        this.cellWidth -= zoomSpan
        this.cellHeight -= zoomSpan
        let zoomMinus = {cellWidth: this.cellWidth, cellHeight: this.cellHeight}
        this.setZoomValueStorage(zoomMinus)
      }
    },
    async getDashboardLastSendTimeMillisecond() {
      await this.$axios.get('socket/get-dashboard-last-send-time')
        .then(res => {
          this.dashboardLastSendTime = res.data.dashboardLastSendTimeInMillisecond
        })
        .catch(_err => {
          this.dashboardLastSendTime = AppConstants.DASHBOARD_LAST_SEND_TIME_MILLISECOND
        })
    },
    async onShowMissList() {
      this.$refs['missing-items-modal'].showModal(this.queryParam)
    },
    onClickDetail() {
      if (!this.queryStr && !this.selected) {
        return
      }
      const batchObject = BatchTaskUtils.getBatchNoAndBatchDetailNo(this.selected.value)
      const queryTaskStatement = { ...batchObject, showBatchDetails: true }
      BatchTaskUtils.goToTaskDetailPage(queryTaskStatement)
    },
    onShowProductTracking() {
      this.$refs['item-tracking-modal'].showModal(this.queryParam)
    },
    showIconTemporaryHolding(status, temporaryHolding) {
      return (status === 2 || status === 3) || (status === 4 && temporaryHolding === 1)
    },
    /**
     * シュート層のラベルを表示
     * @param {number} chuteLayer ユーザーが選択した値
     */
    displayChuteLayerLabels(chuteLayer) {
      const chuteLayerLabel = this.displayChuteLabels(chuteLayer, this.chuteSelectOptions)
      return chuteLayerLabel
    },
    /**
     * シュートグリッドウィンドウを開く
     */
    openChuteGridWindow() {
      WindowUtils.closeWindow(AppConstants.CHUTE_GRID_WINDOW)
      // ウィンドウを最大化するために通常の画面でダッシュボード データをコピーします。
      const indexChutePlayer = this.findIndexChuteLayer(this.chuteLayerStorage)
      this.updateChuteLayerFullscreen(this.chuteLayers[indexChutePlayer] || 0)
      this.updateChuteZoomValueFullscreen({cellWidth: this.cellWidth, cellHeight: this.cellHeight})
      this.updateChuteInfoDisplayFullscreen(this.modeDisplay)
      // 開いてウィンドウを最大化するときに、バッチをストレージに保存します。
      this.updateBatchSelected((this.selected && this.selected.value) || '')
      WindowUtils.openMaximizedWindow(AppConstants.CHUTE_GRID_WINDOW, 'fullscreen=true')
    },
    resetTimer() {
      this.lastRequestTime = '更新停止中'
      this.lastRequestDate = '更新停止中'
      clearInterval(this.intervalId)
    },
    /**
     * ストレージ内のズーム値を更新します。
     * @param data - ズーム値
     */
    setZoomValueStorage(data) {
      if (this.fullScreen) {
        this.updateChuteZoomValueFullscreen(data)
      } else {
        this.updateChuteZoomValue(data)
      }
    },
    /**
     * ストレージのシュート情報を更新します。
     */
    setChuteInfoDisplay() {
      if (this.fullScreen) {
        this.updateChuteInfoDisplayFullscreen(this.modeDisplay)
      } else {
        this.updateChuteInfoDisplay(this.modeDisplay)
      }
    },
    /**
     * ストレージのシュート層を更新します。
     * @param chuteSelected - シュートが選択されました
     */
    setChuteLayerStorage(chuteSelected) {
      const chuteLayer = this.chuteLayers[chuteSelected] || 0
      if (this.fullScreen) {
        this.updateChuteLayerFullscreen(chuteLayer)
      } else {
        this.updateChuteLayer(chuteLayer)
      }
    },
    /**
     * インデックス シュート層を見つけます。
     * @param {Number} chuteLayer - シュート層。
     */
    findIndexChuteLayer(chuteLayer) {
      const indexChuteLayer = this.chuteLayers.findIndex(item => Number.parseInt(item) === chuteLayer)
      return indexChuteLayer !== -1 ? indexChuteLayer : 0
    }
  },
  computed: {
    isNoDataPieChart() {
      if (this.isLoading) {
        return false
      }
      // 円グラフ オプション シリーズの長さは少なくとも 1 (「データなし」) です
      return !this.pie_options || !this.pie_options.series || !this.pie_options.series[0] || this.pie_options.series[0].data.length <= 1
    },
    isNoWorkTaskType() {
      return this.selected ? this.selected.isNoWorkTaskType : false
    },
    isOrderTaskType() {
      return !this.isNoWorkTaskType
    },
    isDisplayedMissingListBtn() {
      return this.isOrderTaskType && this.selected && ([2, 3, 4].includes(this.selected.status) || (this.selected.status === 5 && this.selected.missingFlag === 1))
    },
    fullScreen() {
      const paramObj = RouterUtils.getUrlParam(document.location.href)
      return paramObj && paramObj.fullscreen
    },
    calcTableWidth: function () {
      if (this.gridxSize !== 0) {
        return (((this.cellWidth + 4) * this.gridxSize) - 4) + 'px'
      } else {
        return 'auto'
      }
    },
    calcCellFont: function () {
      if (this.cellWidth < 40) {
        return { chuteStatusFontSize: 16, chuteNameFontSize: 4, chuteIconFontSize: 8 }
      } else if (this.cellWidth < 60) {
        return { chuteStatusFontSize: 16, chuteNameFontSize: 8, chuteIconFontSize: 16 }
      } else if (this.cellWidth < 80) {
        return { chuteStatusFontSize: 16, chuteNameFontSize: 12, chuteIconFontSize: 19 }
      } else if (this.cellWidth < 100) {
        return { chuteStatusFontSize: 16, chuteNameFontSize: 12, chuteIconFontSize: 24 }
      } else if (this.cellWidth < 160) {
        return { chuteStatusFontSize: 20, chuteNameFontSize: 14, chuteIconFontSize: 30 }
      } else {
        return { chuteStatusFontSize: 25, chuteNameFontSize: 16, chuteIconFontSize: 40 }
      }
    },
    chuteGridData: function() {
      if (this.chuteSelected !== null && this.chuteSelected > -1) {
        return this.chuteGridDatas[this.chuteSelected]
      } else {
        return null
      }
    },
    countByLayer: function() {
      if (this.chuteSelected !== null && this.chuteSelected > -1) {
        let item = this.countByLayerData[this.chuteSelected]
        return {chute: { complete: item.chuteCompleteCount, total: item.chuteTotalCount }, task: { complete: item.taskCompleteCount, total: item.taskTotalCount }}
      } else {
        return {chute: { complete: null, total: null }, task: { complete: null, total: null }}
      }
    },
    /**
     * 電卓サイズの横棒
     */
    calcHorizonntalBar() {
      if (this.horizontalData && this.horizontalData.labels.length > 3) {
        return 'width: 100%;'
      }
      return 'width: 100%; height: 100%;'
    },
    chuteZoomValueStorage() {
      if (this.fullScreen) {
        return this.getChuteZoomValueFullscreen
      }
      return this.getChuteZoomValue
    },
    chuteInfoDisplayStorage() {
      if (this.fullScreen) {
        return this.getChuteInfoDisplayFullscreen
      }
      return this.getChuteInfoDisplay
    },
    chuteLayerStorage() {
      if (this.fullScreen) {
        return this.getChuteLayerFullscreen
      }
      return this.getChuteLayer
    },
    ...mapState('socket', ['messages']),
    ...mapGetters('dashboard', ['getChuteZoomValue', 'getChuteInfoDisplay', 'getChuteLayer',
      'getChuteZoomValueFullscreen', 'getChuteInfoDisplayFullscreen', 'getChuteLayerFullscreen', 'getBatchSelected'])
  },
  data() {
    return {
      STATUS_STOP: STATUS_STOP,
      windowWidth: window.innerWidth,
      colors: {
        未割当: '#D2DAFE',
        割当済: '#DC9DC0',
        スタンバイ中: '#E4799B',
        走行中: '#EA5F7F',
        完了: '#AFAFAE',
        終了: '#D6D6D6'
      },
      showChuteName: true,
      htmlLegend: null,
      isFirst: 0,
      queryStr: null,
      queryParam: {},
      lastRequestTime: 'ロード中...',
      lastRequestDate: 'ロード中...',
      isGettingData: false,
      isBatchChanged: false,
      taskData: {},
      selected: null,
      selectOptions: [],
      pie_options: {
        animation: false,
        tooltip: {
          trigger: 'item',
          formatter: '{b}',
          show: false
        },
        series: [
          {
            type: 'pie',
            radius: ['33%', '88%'],
            labelLine: {
              show: false
            },
            label: {
              show: false
            },
            itemStyle: {
              borderColor: '#ffffff',
              borderWidth: 3
            },
            silent: true,
            data: [{
              value: 1,
              name: 'No data',
              itemStyle: {
                color: '#eeeeee'
              }
            }]
          }
        ]
      },
      horizontalData: null,
      options: {
        layout: {
          padding: {
            right: 165,
            top: 18
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        tooltips: {
          mode: 'point',
          yAlign: 'bottom'
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              ticks: {
                beginAtZero: true,
                // min: 0,
                // max: 10,
                stepSize: 5,
                maxTicksLimit: 10
              },
              gridLines: {
                color: '#E5F0F7',
                lineWidth: 2,
                zeroLineWidth: 2,
                zeroLineColor: '#E5F0F7'
              }
            }
          ],
          yAxes: [
            {
              stacked: true,
              display: true,
              ticks: {
                fontSize: 14,
                fontColor: '#252D38',
                padding: 15,
                autoSkip: false
              },
              gridLines: {
                display: false
              }
            }
          ]
        }
      },
      gridxSize: 0,
      gridySize: 0,
      chuteSelected: null,
      chuteSelectOptions: [],
      countByLayerData: [],
      cellWidth: defaultCellWidth,
      cellHeight: defaultCellHeight,
      chuteGridDatas: null,
      chuteLayers: [],
      chuteCellColorClass: [
        '',
        'chute_grid_progress_less_quarter',
        'chute_grid_progress_less_half',
        'chute_grid_progress_less_three_quarters',
        'chute_grid_progress_less_finish',
        'chute_grid_progress_finish'
      ],
      totalTaskByChute: null,
      totalTaskByChuteCompleted: null,
      isLoading: false,
      modeDisplay: 0,
      modeDisplayLetters: [{value: 0, text: 'シュートNoと名を順に表示'}, {value: 1, text: 'シュート名を優先して表示'}, {value: 2, text: 'シュートNoのみ表示'}],
      DEFAULT_CHUTE_DISPLAY_MODE: DEFAULT_CHUTE_DISPLAY_MODE,
      PRIORITY_CHUTE_NAME_DISPLAY_MODE: PRIORITY_CHUTE_NAME_DISPLAY_MODE,
      ONLY_CHUTE_NO_DISPLAY_MODE: ONLY_CHUTE_NO_DISPLAY_MODE,
      lastSendTimeMillisecond: null,
      dashboardLastSendTime: null,
      pageReload: false,
      isReloadChute: false,
      intervalId: null,
      intervalTime: 5,
      isShowMissingModal: false,
      isShowTrackingModal: false,
      dataFetchingTimer: null,
      dashboard: {},
      isShowBatchDetailNo: false,
      stopDashboardInterval: false
    }
  }
}
</script>

<style lang="scss" scoped>
.content-are {
  padding-right: 16px;
  padding-left: 16px;
  margin-right: -16px;
  margin-left: -16px;
  overflow: auto;
}
.batch_select {
  padding: 16px 0;
  .last-time {
    &__date {
      @include responsive-fs(32);
      font-weight: bold;
      margin-right: 16px;
    }
    &__hour {
      @include responsive-fs(16);
      font-weight: bold;
      margin-right: 16px;
    }
  }
  .label {
    @include responsive-fs(12);
    font-weight: 400;
    margin-right: 8px;
  }
  select {
    /* width: 134px; */
    height: 38px;
    border: 1px solid #AFAFAE;
    border-radius: 4px;
  }
}

.btn-group-custom {
  display: flex;
  padding-left: 0px;
  padding-right: 0px;
  @include responsive-fs(12);
  border: none;
  margin-left: auto;
  .no-bg {
    @include responsive-fs(12);
    color: #4E66A6;
    background-color: white;
    border: 1px solid #4E66A6;
    border-radius: 4px;
    margin-left: 16px;
    width: fit-content;
    white-space: nowrap;
  }
}
.title_bar {
  height: 50px;
  margin-bottom: 16px;
  align-content: flex-end;
  font-weight: bold;
  padding-bottom: 2px;
  @include responsive-fs(18);
}
.card {
  height: 500px;
  overflow: hidden;
  padding: 16px 24px;
  border: none;
  box-shadow: 0px 4px 10px rgba(51, 51, 51, 0.12);
  border-radius: 4px;
  min-height: 150px;
  @include media-breakpoint-default() {
    padding: 8px 16px;
    height: 310px;
  }
  .progress_text {
    .label {
      @include responsive-fs(12);
      margin-right: 8px;
    }
    .number {
      @include responsive-fs(24);
      font-weight: 900;
    }
  }
}

.card-title {
  @include responsive-fs(20);
  font-weight: 700;
  margin-bottom: 8px;
}

.pie-chart {
  position: relative;
  min-width: 15%!important;
  max-width: 320px!important;
  width: 30%!important;
  flex: 1 1;
  height: 320px!important;
  @include media-breakpoint-default() {
    max-width: 130px!important;
    height: 180px!important;
  }
  .donut_empty_data {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    color: $form_border_color;
  }
}
.donut_legend {
  line-height: 1.7;
  padding-left: 0;
  min-width: 140px;
  margin-left: 14px;
  margin-bottom: 0;
  flex-shrink: 0;
  @include media-breakpoint-default() {
    min-width: 130px;
    margin-left: 8px;
  }
  .status_text {
    display: inline-block;
    width: fit-content;
    white-space: nowrap;
    margin-right: 21px;
    flex-shrink: 1;
    position: relative;
    @include media-breakpoint-large() {
      margin-right: 4px;
      @include responsive-fs(12);
    }
    @include media-breakpoint-default() {
      margin-right: 0px;
      @include responsive-fs(10);
    }
  }

  .percent {
    width: fit-content;
    min-width: 80px;
    white-space: nowrap;
    @include responsive-fs(20);
    font-weight: bold;
    text-align: right;
    @include media-breakpoint-large() {
      min-width: 60px;
    }
    @include media-breakpoint-default() {
      min-width: 50px;
    }
  }
}
.circle_color {
  border: 4px solid #ddd;
  width: 12px;
  height: 12px;
  display: inline-block;
  margin-right: 8px;
  border-radius: 50%;
  position: relative;
  top: 2px;
  @include media-breakpoint-default() {
    margin-right: 4px;
  }
}
.chute_lagend {
  text-align: right;
  @include responsive-fs(12);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  span + span {
    margin-left: 12px;
  }
  span::before {
    content: '';
    width: 24px;
    height: 24px;
    display: inline-block;
    position: relative;
    top: 8px;
    margin-right: 4px;
  }
  .comp::before {
    background: #AFAFAE;
  }
  .incomp::before {
    background: #D2DAFE;
  }
}
.empty_data {
  position: absolute;
  top: calc(50% - 60px);
  text-align: center;
  width: 100%;
  color: $form_border_color;
}
.full-screen-chute-grid {
  background-color: #ffffff;
}
.normal-screen-chute-grid {
  background-color: #f8f8f8;
}
.height-chute-info {
  min-height: 70px;
}
.chute_grid_progress {
  height: auto;
  overflow: auto;
  padding: 10px 24px 24px 24px;
  margin-bottom: 16px;
  @include media-breakpoint-large() {
    padding: 10px 16px 16px 16px;
  }
  .chute-grid-control {
    .select-mode-display-chute {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1 1;
    }
    .card-title {
      margin-bottom: 0;
      margin-right: 32px;
      @include media-breakpoint-default() {
        margin-right: 16px;
      }
    }
    .btn-zoom {
      border: none;
      outline: none;
      background: none;
      color: #4E66A6;
      display: flex;
      align-items: center;
      @include responsive-fs(12);
      font-weight: bold;
      padding: 5px;
      margin-right: 4px;
      &:hover {
        opacity: 0.7;
      }
      @include media-breakpoint-default() {
        padding: 5px 6px 5px 0px;
        .title {
          display: none;
        }
      }
      .zoom-in-icon, .zoom-out-icon {
        @include responsive-fs(24);
        margin-right: 5px;
      }
    }
    .icon-zoom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-left: auto;
      padding: 4px;
      cursor: pointer;
      @include media-breakpoint-default() {
        width: fit-content;
        .title {
          display: none;
        }
      }
      span {
        width: fit-content;
        white-space: nowrap;
        @include responsive-fs(12);
        font-weight: 700;
        margin-left: 4px;
        color: $sucess;
      }
      .zoom-out-map-icon {
        @include responsive-fs(18);
        font-weight: normal;
      }
    }
  }
  .chute_grid_legend {
    margin: 0 32px;
    @include media-breakpoint-large() {
      margin: 0px 10px;
    }
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 40px;
      width: fit-content;
      min-height: 27px;
      border-radius: 4px;
      @include responsive-fs(12);
      margin-right: 4px;
      &.chute_grid_progress_less_quarter {
        border: 1px solid #D6D6D6;
      }
    }
  }
  .chute_grid_progress_less_quarter {
    background:#F8F8F8;
    padding: 0 4px;
    color: #252422;
    border: 2px solid #F8F8F8;
    &__percent {
      border: none;
    }
  }
  .chute_grid_progress_less_half {
    background:#D7B9DD;
    padding: 0 4px;
    color: #252422;
    border: 2px solid #D7B9DD;
    &__percent {
      border: none;
    }
  }
  .chute_grid_progress_less_three_quarters {
    background:#E184A6;
    padding: 0 4px;
    color: #252422;
    border: 2px solid #E184A6;
    &__percent {
      border: none;
    }
  }
  .chute_grid_progress_less_finish {
    background:#EA5F7F;
    padding: 0 4px;
    color: #252422;
    border: 2px solid #EA5F7F;
    &__percent {
      border: none;
    }
  }
  .chute_grid_progress_finish {
    color: #ffffff;
    background:#666563;
    padding: 0 4px;
    border: 2px solid #666563;
    &__percent {
      border: none;
    }
  }
  .table_wrapper {
    margin: 10px 0 0;
    padding: 8px 10px;
    background-color: #D6D6D6;
    overflow: auto;
    width: 100%;
    .chute_grid_table {
      .table {
        margin-bottom: 0;
        .tr {
          display: flex;
          .td {
            margin-right: 4px;
            flex-shrink: 0;
            &.start {
              padding-top: 2px;
              .td-cotnent {
                border-top-left-radius: 4px;
                border-top-right-radius: 4px;
              }
              .chute-stop {
                border-top-left-radius: 4px;
                border-top-right-radius: 4px;
              }

            }
            &.end {
                padding-bottom: 2px;
                .td-cotnent {
                  border-bottom-left-radius: 4px;
                  border-bottom-right-radius: 4px;
                }
            }
            &.no-progress {
              .td-cotnent {
                background: none;
                border-right: 2px solid #ffffff;
                border-left: 2px solid #ffffff;
              }
              &.start {
                .td-cotnent {
                  border-top: 2px solid #ffffff;
                }
              }
              &.end {
                .td-cotnent {
                  border-bottom: 2px solid #ffffff;
                }
              }
            }
            .td-cotnent {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              position: relative;
              cursor: pointer;
              height: 100%;
              width: 100%;
              .chute_name {
                @include responsive-fs(var(--chuteNameFontSize), false);
              }
              .chute_status {
              @include responsive-fs(var(--chuteStatusFontSize), false);
              font-weight: bold;
              width: 100%;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              text-align: center;
              @include textOverflowEllipsis(false, 1)
            }
            .chute-stop {
              display: flex;
              justify-content: center;
              align-items: center;
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 30%;
              background-color: rgba(37, 36, 34, 0.6);
              color: #ffffff;
              i {
                display: block;
                max-width: 24px;
                height: 24px;
              }
            }
            .chute_info {
              position: absolute;
              bottom: 4%;
              @include media-breakpoint-xx-large() {
                transform: translateY(10%);
              }
              margin-bottom: 0;
              padding: 0 2px;
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            }
          }
        }
      }
    }
  }
  .full-chute {
    animation: flash 1s linear infinite;
  }
  @keyframes flash {
    0%,100% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
  }
}

.horizontal-bar-sort {
  margin-top: 8px;
  button {
    width: 80px;
    height: 27px;
    border: 2px solid rgba(78, 102, 166, 0.24);
    background-color: #ffffff;
    border-radius: 4px;
    margin-left: 4px;
    box-shadow: none;
    outline: none;
    @include responsive-fs(12);
    &.completed {
      background-color: #AFAFAE;
    }
    &.incomplete {
      background-color: #D2DAFE;
    }
  }
}

.multiselect-batch {
  width: 720px;
  min-width: 250px;
}

.select-batch {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  height: 38px;
  width: 100%;
  font-weight: bold;
  line-height: normal;
  &__border {
    border-bottom: 1px solid #D6D6D6;
  }
  &__status {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 110px;
    width: 15%;
    min-width: 40px;
    @include media-breakpoint-xx-large() {
      width: 40px;
    }
    height: 24px;
    margin-right: 9px;
    white-space: nowrap;
    flex-shrink: 0;
    i {
      display: block;
      width: 24px;
      color: #4E66A6;
    }
    small {
      line-height: 12px;
    }
  }
}

.icon-report {
  @include responsive-fs(16);
  color: #B41B3E;
  white-space: nowrap;
  align-items: center;
  display: flex;
  margin-left: auto;
  font-weight: normal;
  .icon {
    @include responsive-fs(12);
  }
  .label {
    margin-left: 4px;
    @include responsive-fs(16);
  }
}

.dashboard-active-bar {
  display: flex;
  align-items: center;
  padding: 16px 0;
  &__date {
    @include responsive-fs(32);
    font-weight: bold;
    margin-right: 16px;
    }
  &__hour {
    font-weight: bold;
    margin-right: 16px;
    flex-shrink: 0;
  }
}

.text-overflow-ellipsis {
  // 50px 矢印とパディングのサイズ
  max-width: calc(100% - 50px);
  @include responsive-fs(16);
  @include textOverflowEllipsis(false, 1)
}
</style>



// WEBPACK FOOTER //
// src/components/TsortDashboard.vue